import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=38bf21d4"
import script from "./MainSlide.vue?vue&type=script&lang=ts"
export * from "./MainSlide.vue?vue&type=script&lang=ts"
import style0 from "./MainSlide.vue?vue&type=style&index=0&id=38bf21d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports